
import store from '@/store'
import { getToken } from './auth'
if (getToken()) {
  store.dispatch('user/findMerchantBaseInfo')
  store.dispatch('common/getContants')
  store.dispatch('common/getSystemContants')
  store.dispatch('common/getBanks')
}